import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SelectReact from 'react-select'
import InputLabel from '@material-ui/core/InputLabel';
import formStyle from "../../styles/forms"
import ProjectService from "../../services/projects";
import { FormControlLabel, Checkbox } from "@material-ui/core";
export default function ProjectEdit(props) {
  let [latestPojectNr, SetProjectNr] = useState('');

  useEffect(() => {
    if (props.items.length > 0) {
      let newNr = ProjectService.getLatestProjectNr(props.items) + 1;
      SetProjectNr(newNr);

      if (!props.item.projectnumber) {
        let item = Object.assign({}, props.item);
        item.projectnumber = '' + newNr;
        props.handleUpdate(item);
      }
    }
  }, [props.items, props.item])

  let update = (ev) => {
    let item = props.item;

    if (ev.target.id === 'inactive' || ev.target.id === 'isholiday' || ev.target.id === 'isdocter' || ev.target.id === 'isbaby') {
      item[ev.target.id] = ev.target.checked
    } else {
      item[ev.target.id] = ev.target.value;
    }

    props.handleUpdate(item);
  }

  let updateClient = (ev) => {
    let item = props.item;
    if (!item.client) { item.client = {} }
    item.client._id = ev.value;
    props.handleUpdate(item);
  }

  let updateType = (ev) => {
    let item = props.item;
    item.type = ev.target.value;
    props.handleUpdate(item);
  }
  let clientOptions = props.clients.map((client) => { return { value: client._id, label: client.name + ', ' + client.town } })
  let getSelectedOption = (client) => {
    let id = (client ? client._id : 0);
    return clientOptions.filter((item) => { return item.value === id });
  }
  return (
    <div className="padding">

      <TextField
        autoFocus
        margin="dense"
        id="projectnumber"
        label="Nummer"
        type="text"
        value={props.item.projectnumber || latestPojectNr}
        onChange={update}
        fullWidth
        required
      />
      <TextField
        margin="dense"
        id="name"
        label="Naam"
        type="text"
        value={props.item.name || ""}
        onChange={update}
        fullWidth
        required
      />
      <TextField
        multiline
        margin="dense"
        id="description"
        label="Omschrijving"
        type="text"
        value={props.item.description || ""}
        onChange={update}
        fullWidth
      />
      <TextField
        multiline
        margin="dense"
        id="purchesorders"
        label="Inkoopnummer(s)"
        type="text"
        value={props.item.purchesorders || ""}
        onChange={update}
        fullWidth
      />
      <br /><br />
      <div className="label">Klant *</div>
      <SelectReact options={clientOptions} onChange={updateClient} value={getSelectedOption(props.item.client)} />

      <br /><br />
      <FormControl>
        <InputLabel htmlFor="type">Type *</InputLabel>
        <Select
          required
          style={formStyle.selectField}
          value={props.item.type || 0}
          onChange={updateType}
          inputProps={{
            name: 'type',
            id: 'type',
          }}
        >
          <MenuItem value={0}>{ProjectService.getProjectType(0)}</MenuItem>
          <MenuItem value={1}>{ProjectService.getProjectType(1)}</MenuItem>
          <MenuItem value={2}>{ProjectService.getProjectType(2)}</MenuItem>
        </Select>
      </FormControl>
      <br /><br />
      <FormControlLabel
        control={
          <Checkbox
            id="inactive"
            checked={props.item.inactive === true}
            onChange={update}
          />}
        label="Inactief"
      />
      <br /><br />
      <FormControlLabel
        control={
          <Checkbox
            id="isholiday"
            checked={props.item.isholiday === true}
            onChange={update}
          />}
        label="Wordt gebruikt voor opgaaf vakantieuren"
      />
      <br /><br />
      <FormControlLabel
        control={
          <Checkbox
            id="isdocter"
            checked={props.item.isdocter === true}
            onChange={update}
          />}
        label="Wordt gebruikt voor opgaaf tandarts/huisarts/specialist"
      />
      <br /><br />
      <FormControlLabel
        control={
          <Checkbox
            id="isbaby"
            checked={props.item.isbaby === true}
            onChange={update}
          />}
        label="Wordt gebruikt voor opgaaf ouderschapsverlof"
      />


    </div>
  );

}

